import React, { SVGProps } from 'react';

interface IIcons24LightChevronSmallChevronDownSMProps extends SVGProps<SVGSVGElement> {
  className?: string;
}
export const Icons24LightChevronSmallChevronDownSM = ({
  className,
}: IIcons24LightChevronSmallChevronDownSMProps): JSX.Element => (
  <svg className={className} xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'>
    <g fill='none' fillRule='evenodd'>
      <g fill='#009EAD'>
        <g>
          <g>
            <g>
              <g>
                <path
                  d='M15.854 13.646l-3.5-3.5c-.195-.195-.512-.195-.707 0l-3.5 3.5c-.196.195-.196.512 0 .707.098.098.226.147.352.147.128 0 .256-.049.354-.147L12 11.207l3.147 3.146c.098.098.226.147.353.147.128 0 .256-.049.354-.147.196-.195.196-.512 0-.707'
                  transform='translate(-296 -304) translate(47 88) translate(0 200) translate(210.75) translate(38.25 16) matrix(1 0 0 -1 0 24.5)'
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

Icons24LightChevronSmallChevronDownSM.defaultProps = {
  className: '',
};

export default Icons24LightChevronSmallChevronDownSM;
